import React, {useEffect, useState} from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Checkbox,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  addUsersToRiskAssessment,
  removeUserFromRiskAssessment,
} from '../../../../../../../../redux/risk-assessment/riskAssessmentSlice';
import {useLocation} from 'react-router-dom';
import {getUserListSelector} from '../../../../../../../../redux/selectors/userList';
import {useDispatch, useSelector} from 'react-redux';
import Button from '../../../../../../../../components/form/button/button';
import {getRiskAssessmentStateSelector} from '../../../../../../../../redux/selectors/riskAssessment';
import CustomSelect from '../../../../../../../../components/form/customSelect/customSelect';
import closeIcon from '../../../../../../../../assets/icons/close-icon.svg';
import {apiFunctions} from '../../../../../../../../api/functions';
import Confirmation from '../../../../../../../../components/confirmation/confirmation';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};
const UserModal = ({open, onClose}) => {
  const location = useLocation();

  const raData = location?.state?.selectedRiskAssessment;

  const riskAssessmentId = raData?.id;

  const [userExists, setUserExists] = useState(false);

  const userListState = useSelector(getUserListSelector());

  const dispatch = useDispatch();

  const [userList, setUserList] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);

  const [tempUsers, setTempUsers] = useState([]);

  const riskAssessments = useSelector(getRiskAssessmentStateSelector());

  const specificRiskAssessment = riskAssessments.find(
    ra => ra.id === riskAssessmentId,
  );

  const riskAssessmentUsers = specificRiskAssessment?.users || [];

  useEffect(() => {
    setSelectedUsers(riskAssessmentUsers);

    setTempUsers(riskAssessmentUsers);
  }, [riskAssessmentUsers]);

  useEffect(() => {
    const formattedData = userListState?.userList?.map(item => {
      return {
        label:(!item?.first_name && !item?.last_name)? item?.email:`${item?.first_name ?? "N/A"} ${item?.last_name ?? ""}`,
        value: item?.id,
      };
    });
    setUserList(formattedData || []);
  }, [userListState]);

  const handleCheckUserExists = async () => {
    const userIds = tempUsers?.filter(temp => !selectedUsers?.includes(temp));
    const response = await apiFunctions.checkAttendanceExists({
      riskAssessmentId,
      userIds,
    });

    if (response.status === 200) {
      const exists = response.data.attendanceExists;

      if (exists) {
        setUserExists(exists);
      } else {
        handleAddUsers();
      }
      // return exists; // true or false
    }
  };

  const handleAddUsers = () => {
    const removedUsers = tempUsers?.filter(
      temp => !selectedUsers?.includes(temp),
    );
    const addedUsers = selectedUsers?.filter(
      temp => !tempUsers?.includes(temp),
    );
    // console.log(riskAssessmentId,selectedUsers)

    dispatch(
      addUsersToRiskAssessment({
        id: riskAssessmentId,
        userIds: selectedUsers,
        removedUsers,
        addedUsers,
        callback: response => {
          onClose(true);
          // Handle success
          // console.log('Users added successfully', response);
        },
      }),
    );
  };

  const handleChange = values => {
    // const a=new Set([...values,...riskAssessmentUsers])

    // const updatedData=Array.from(a)
    // setSelectedUsers(updatedData)
    setSelectedUsers(values);
  };
  
  const toggleCheckbox = (e,value) => {
    if(e.target.checked){
      setSelectedUsers(prev => [...prev,value])
    }else{
      setSelectedUsers(prev => prev.filter(item => item !== value))
    }
  
  };
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={style}>
          <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography variant="h5" style={{fontWeight: 'bold'}}>
              Risk Assessment Users
            </Typography>
            <img
              onClick={onClose}
              src={closeIcon}
              alt="close"
              style={{cursor: 'pointer'}}
            />
          </Box>


          <Box sx={{mt: 2}}>
          <Typography style={{fontWeight: 'bold'}}>Select Users</Typography>
          <List style={{maxHeight: '180px', overflowY: 'auto'}}>
            {userList?.map(attendee => (
              <ListItem
                className="attendance-list"
                key={attendee.value}
                sx={{px: 0}}>
                <ListItemIcon className="attendance-list-item-icon">
                  <Checkbox
                    checked={selectedUsers?.includes(attendee.value)}
                    onChange={(e) => toggleCheckbox(e,attendee.value)}
                  />
                </ListItemIcon>
                <ListItemText primary={attendee?.label} />
              </ListItem>
            ))}
          </List>
        </Box>

          {/* <CustomSelect
          label={"Select Users"}
            options={userList}
            value={selectedUsers}
            handleChange={e => handleChange(e.target.value)}
            isMultiple
          /> */}

          <div className="save-session">
            <Button
              variant="secondary-button"
              clickHandler={
                tempUsers?.length > selectedUsers?.length
                  ? handleCheckUserExists
                  : handleAddUsers
              }>
              Save Users
            </Button>
          </div>


          {userExists && (
            <Confirmation
              style={{zIndex:99999}}
              label={
                'Removing these users will remove all existing attendance data for the removed users in this Risk Assessment. Do you want to proceed?'
              }
              show={userExists}
              setShow={setUserExists}
              // confirmationType={'typeDelete'}
              primaryButtonText="Remove"
              secondaryButtonText="Cancel"
              primaryButtonClickHandler={handleAddUsers}
              secondaryButtonClickHandler={() => setUserExists(false)}
            />
          )}
        </Box>
      </Modal>
    </>
  );
};

export default UserModal;
